import { render, staticRenderFns } from "./card-head.vue?vue&type=template&id=32033138"
import script from "./card-head.vue?vue&type=script&lang=ts"
export * from "./card-head.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32033138')) {
      api.createRecord('32033138', component.options)
    } else {
      api.reload('32033138', component.options)
    }
    module.hot.accept("./card-head.vue?vue&type=template&id=32033138", function () {
      api.rerender('32033138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/legacy/card/card-head.vue"
export default component.exports